import { render, staticRenderFns } from "./LvBackupSetting.vue?vue&type=template&id=083a2e4e&scoped=true"
import script from "./LvBackupSetting.vue?vue&type=script&lang=js"
export * from "./LvBackupSetting.vue?vue&type=script&lang=js"
import style0 from "./LvBackupSetting.vue?vue&type=style&index=0&id=083a2e4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083a2e4e",
  null
  
)

export default component.exports